// extracted by css-extract-rspack-plugin
export default {"bracket-round":"QpYwQsiF","bracket-round__slot":"GEz00q51","bracket-round__label":"AsOaqZHB","bracket-round__label--top":"ZlvCh5Ii","bracket-round__label--bottom":"XcZ1xnSp"};